import { render, staticRenderFns } from "./myProject.vue?vue&type=template&id=f472d4ec&scoped=true"
import script from "./myProject.vue?vue&type=script&lang=js"
export * from "./myProject.vue?vue&type=script&lang=js"
import style0 from "./myProject.vue?vue&type=style&index=0&id=f472d4ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f472d4ec",
  null
  
)

export default component.exports